import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import IBaseState from '../../types/IBaseState';
import AuthService from '../services/AuthService';
import { LOGOUT } from '../../constants/actions/auth.constants';

const NAME = 'AUTH';

const requestResetPassword = createAsyncThunk(
    `${NAME}/requestResetPassword`,
    AuthService.requestResetPassword,
);
const resetPassword = createAsyncThunk(
    `${NAME}/resetPassword`,
    AuthService.resetPassword,
);

type AuthState = {
    password: { request: IBaseState<unknown>; reset: IBaseState<unknown> };
};

const initialState: AuthState = {
    password: {
        request: {
            data: null,
            loading: false,
            success: false,
            error: false,
        },
        reset: {
            data: null,
            loading: false,
            success: false,
        },
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        reinit: (state) => {
            state.password = initialState.password;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(requestResetPassword.pending, (state) => {
            state.password.request.loading = true;
            state.password.request.success = false;
        });
        builder.addCase(requestResetPassword.fulfilled, (state) => {
            state.password.request.loading = false;
            state.password.request.success = true;
        });
        builder.addCase(requestResetPassword.rejected, (state) => {
            state.password.request.loading = false;
            state.password.request.success = false;
            state.password.request.error = true;
        });

        builder.addCase(resetPassword.pending, (state) => {
            state.password.reset.loading = true;
            state.password.reset.success = false;
        });
        builder.addCase(resetPassword.fulfilled, (state) => {
            state.password.reset.loading = false;
            state.password.reset.success = true;
        });
        builder.addCase(resetPassword.rejected, (state) => {
            state.password.reset.loading = false;
            state.password.reset.success = false;
        });
        builder.addCase(LOGOUT, () => initialState);
    },
});

const AuthActions = {
    requestResetPassword,
    resetPassword,
    ...slice.actions,
};

export default AuthActions;
export const AuthReducer = slice.reducer;
